function ConnectionService($auth, ApiService) {
  'ngInject';

  const service = {};
  service.connectAmazon = function (url,callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.postToAmazon = function (amazonForm, callbackFunc) {
    let data = {
      mws_marketplace_id: amazonForm.marketplaceId,
      mws_merchant_id: amazonForm.merchantId,
      aws_access_key_id: amazonForm.accessKey,
      aws_secret_access_key: amazonForm.secretKey,
      auth_token: amazonForm.authToken,
      api_v1_organization_id: amazonForm.org.id
    };
    ApiService.post(`/amazon_connections.json`, data, callbackFunc);
  };

  service.updateAmazonCon = function (amazonForm, conId, callbackFunc) {
    let data= {
      mws_marketplace_id: amazonForm.marketplaceId,
      mws_merchant_id: amazonForm.merchantId,
      aws_access_key_id: amazonForm.accessKey,
      aws_secret_access_key: amazonForm.secretKey,
      auth_token: amazonForm.authToken,
      api_v1_organization_id: amazonForm.org.id
    };
    ApiService.put(`/amazon_connections/${conId}.json`, data, callbackFunc);
  };

  service.editAmazonCon = function (conId,callbackFunc) {
    ApiService.get(`/amazon_connections/${conId}.json`, callbackFunc);
  };

  service.deleteAmazon = function (conId, callbackFunc) {
    ApiService.delete(`/amazon_connections/${conId}.json`, {}, callbackFunc);
  };

  let headers = $auth.retrieveData('auth_headers');
  service.xeroInfo = function(callbackFunc) {
    ApiService.get(`/xero/logged_xero_info.json`, callbackFunc);
  };


  service.disconnect = function(organization_id, callbackFunc) {
    ApiService.put(`/xero/disconnect/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.archiveXero = function(organization_id, callbackFunc) {
    ApiService.put(`/xero/archive/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.unarchiveXero = function(organization_id, callbackFunc) {
    ApiService.put(`/xero/unarchive/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.scheduleXeroPurge = function(organization_id, days, callbackFunc) {
    ApiService.put(`/xero/schedule_purge/?&organization_id=${organization_id}&days=${days}`, {}, callbackFunc);
  };

  service.cancelXeroPurge = function(organization_id, callbackFunc) {
    ApiService.put(`/xero/cancel_purge/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.delete = function(organization_id, callbackFunc) {
    ApiService.delete(`/xero/destroy/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.refreshCache = function(organization_id, callbackFunc) {
    ApiService.get(`/xero/refresh_cache/?organization_id=${organization_id}`, callbackFunc);
  };

  service.fullRefresh = function(organization_id, callbackFunc) {
    ApiService.get(`/xero/full_refresh/?organization_id=${organization_id}`, callbackFunc);
  };

  // shopify connection
  service.connectShopify = function (url,callbackFunc) {
    ApiService.get(url, callbackFunc);
  };
 
  service.pendingXeroOrganisations = function (ticket, callbackFunc) {
    ApiService.get('/xero/pending_organisations?ticket=' + encodeURIComponent(ticket), callbackFunc);
  };

  service.selectXeroOrganisation = function (ticket, tenantId, callbackFunc) {
    ApiService.post('/xero/select_organisation', { ticket: ticket, tenant_id: tenantId }, callbackFunc);
  };

  service.getXeroStatus = function (xeroId, callbackFunc) {
    ApiService.get(`/xero/${xeroId}/status.json`, callbackFunc);
  };

  service.getQboConnections = function(url, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.getQboStatus = function(qboId, callbackFunc) {
    ApiService.get(`/qbo/${qboId}/status.json`, callbackFunc);
  };

  service.disconnectQbo = function(organization_id, callbackFunc) {
    ApiService.put(`/qbo/disconnect/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.archiveQbo = function(organization_id, callbackFunc) {
    ApiService.put(`/qbo/archive/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.unarchiveQbo = function(organization_id, callbackFunc) {
    ApiService.put(`/qbo/unarchive/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.refreshQboCache = function(organization_id, callbackFunc) {
    ApiService.get(`/qbo/refresh_cache/?organization_id=${organization_id}`, callbackFunc);
  };

  service.getShopifyOauthConnections = function(url, callbackFunc){
    ApiService.get(url, callbackFunc);
  };

  service.deleteOauthShopify = function (conId, callbackFunc) {
    ApiService.delete(`/shopify_oauth_connections/${conId}.json`, {}, callbackFunc);
  };

  return service;
}

export default {
  name: 'ConnectionService',
  fn: ConnectionService
}
